import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxLoadingComponent } from './ngx-loading.component';
import { NGX_LOADING_CONFIG, NgxLoadingConfig } from './ngx-loading.config';

@NgModule({
  imports: [CommonModule],
  declarations: [NgxLoadingComponent],
  exports: [NgxLoadingComponent]
})
export class NgxLoadingModule {
  static forRoot(config: Partial<NgxLoadingConfig> = {}): ModuleWithProviders<NgxLoadingModule> {
    return {
      ngModule: NgxLoadingModule,
      providers: [{ provide: NGX_LOADING_CONFIG, useValue: config }]
    };
  }
}
